module.exports = __webpack_public_path__ + "img/brand_popup_bg02_m.185491d.092e6389.png";